<template>
  <div style="background: #EFEEF0 0 0 no-repeat">
    <div class="banner">
      <el-carousel indicator-position="outside" height="35vh">
        <el-carousel-item v-for="(item,k) in banners" :key="k">
          <el-image :src="item.ad_img" style="width: 100%;height: 100%;"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="head-lists">
      <div class="weather-application">
        <div class="wa-list">
          <div class="title">
            <span>气象监测</span>
            <span class="wa-go">数据记录 ></span>
          </div>
          <div class="weather-data">
            <div class="weather-list weather-pic">
              <img src="/static/images/sun-nice.png" style="margin-left: 20px;">
              <div class="sun">
                <span>22℃</span>
                <span class="cloud">局部多云</span>
              </div>
            </div>
            <div class="weather-list right-list">
              <div class="indicate">
                <span>空气湿度</span>
                <span>61.0%</span>
              </div>
              <div class="indicate">
                <span>风向</span>
                <span>东南</span>
              </div>
              <div class="indicate">
                <span>空气质量</span>
                <span>良</span>
              </div>
              <div class="indicate">
                <span>风力</span>
                <span>2.0 级</span>
              </div>
              <div class="indicate">
                <span>光照</span>
                <span>111Lux</span>
              </div>
              <div class="indicate">
                <span>风速</span>
                <span>3000m/s</span>
              </div>
              <div class="indicate">
                <span>PM2.5</span>
                <span>3000m/s</span>
              </div>
              <div class="indicate">
                <span>PM10</span>
                <span>3000m/s</span>
              </div>
            </div>
          </div>
        </div>
        <div class="application">
          <div class="title1">
            <span>应用</span>
            <span>快速操作入口</span>
          </div>
          <div class="application-list">
            <div @click="addDevices">
              <img src="/static/images/entry.png">
              <span>录入新设备</span>
            </div>
            <div @click="addGroup">
              <img src="/static/images/create-group.png">
              <span>新建分组</span>
            </div>
            <div @click="addTask">
              <img src="/static/images/new-task.png">
              <span>新建任务</span>
            </div>
            <div @click="goUser">
              <img src="/static/images/manage-users.png">
              <span>用户管理</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="notice-datum">
      <div class="notice-div">
        <div class="title1">
          <span>通知</span>
          <span>以下消息实时更新，请及时处理</span>
        </div>
        <div class="notice-area">
          <div class="notice-info" v-for="(f,i) in info">
            <div>{{f.title}}</div>
            <div>
              <span style="font-size: 12px;">{{f.add_time1}}</span>
              <span style="font-size: 12px;" @click="noticeDetail(i)">详情</span>
            </div>
          </div>
        </div>
      </div>
      <div class="datum-div">
        <div class="title1">
          <span>数据</span>
          <span>以下数据实时更新</span>
        </div>
        <div class="data-list">
          <div class="data-area">
            <div class="data-div">
              <div class="data-first"><p class="data-info">当前用户人数</p><img class="data-img"
                                                                          src="/static/images/data-user.png">
              </div>
              <div class="data-second arrow1">
                <span>{{users}}</span>
                <span @click="goUser">></span>
              </div>
              <div class="data-three">可添加人数：{{6-users}}</div>
            </div>
            <div class="data-div">
              <div class="data-first"><p class="data-info">当前设备数</p><img class="data-img"
                                                                         src="/static/images/data-device.png">
              </div>
              <div class="data-second arrow2">
                <span>{{devices}}</span>
                <span @click="deviceList">></span>
              </div>
              <div class="data-three">运行中设备：{{run}}</div>
            </div>
            <div class="data-div">
              <div class="data-first"><p class="data-info">执行任务</p><img class="data-img"
                                                                        src="/static/images/data-task.png">
              </div>
              <div class="data-second arrow3">
                <span>{{tasks}}</span>
                <span @click="goTasks">></span>
              </div>
              <div class="data-three">分组：{{groups}}</div>
            </div>
            <div class="data-div">
              <div class="data-first"><p class="data-info">当前报警</p><img class="data-img"
                                                                        src="/static/images/data-alarm.png">
              </div>
              <div class="data-second arrow1">
                <span>{{alarm.length.toString()}}</span>
                <span @click="goAlarms">></span>
              </div>
              <div class="data-three">历史报警：{{history_alarm}}</div>
            </div>
            <div class="data-div">
              <div class="data-first"><p class="data-info">即将维保</p><img class="data-img"
                                                                        src="/static/images/data-repair.png">
              </div>
              <div class="data-second arrow2">
                <span>{{repair}}</span>
                <span>></span>
              </div>
              <div class="data-three">累计维保：{{repair}}</div>
            </div>
            <div class="data-div">
              <div class="data-first">
                <p class="data-info">当前分组数</p>
                <img class="data-img" src="/static/images/data-group.png">
              </div>
              <div class="data-second arrow3">
                <span>{{groups}}</span>
                <span @click="groupList">></span>
              </div>
              <div class="data-three">运行中分组：{{run_group.toString()}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="通知详情" :visible.sync="editFormVisible" width="60%" height="90%" style="overflow-y: scroll"
               @click="closeDialog">
      <div>
        <p>标题:</p>
        <p>{{editForm.title}}</p>
      </div>
      <div>
        <p>内容:</p>
        <p v-html="editForm.content"></p>
      </div>
      <div>
        <p>时间:</p>
        <p>{{editForm.add_time1}}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {home, checkAuth} from '../../api/userMG'

  export default {
    data() {
      return {
        loading: false, //是显示加载
        userparm: [], //搜索权限
        listData: [], //用户数据
        devices: 0,
        online: 0,
        alarm: 0,
        repair: 0,
        info: '',
        users: '',
        task_count: 0,
        user: {},
        tasks: 0,
        latlng: '',
        bindPhone: '',
        history_alarm: '',
        status: '',
        infos: '',
        device: 0,
        run: 0,
        groups: 0,
        run_group: 0,
        banners: [],
        editFormVisible: false, //控制编辑页面显示与隐藏
        editForm: {
          title: '',
          content: '',
          add_time1: '',
        },
      }
    },
    // 注册组件
    components: {},
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.InitHome()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      InitHome() {
        home().then(res => {
          let info = res.result || res.data || {}
          this.banners = info.banner
          this.devices = info.devices
          this.online = info.online
          this.alarm = info.alarm
          this.repair = info.repair
          this.online = info.online
          this.info = info.info
          this.users = info.users
          this.task_count = info.task_count
          this.user = info.user
          this.tasks = info.tasks
          this.latlng = info.latlng
          this.bindPhone = info.bindPhone
          this.history_alarm = info.history_alarm
          this.status = info.status
          this.infos = info.infos
          this.device = info.device
          this.run = info.run
          this.groups = info.groups
          this.run_group = info.run_group
        })
      },
      groupList() {
        this.$router.push({path: '/device/group'})
      },
      goAlarms() {
        this.$router.push({path: '/alarm/index'})
      },
      goTasks() {
        this.$router.push({path: '/task/index'})
      },
      deviceList() {
        this.$router.push({path: '/device/index'})
      },
      noticeDetail(i) {
        this.editFormVisible = true
        this.editForm = {title: this.info[i].title, content: this.info[i].content, add_time1: this.info[i].add_time1}
      },
      closeDialog() {
        this.editFormVisible = false
      },
      goUser() {
        let user = JSON.parse(window.localStorage.getItem('userData'))
        checkAuth({phone: user.phone}).then(res => {
          if (res.code == 200 && res.isAdmin == 0) {
            this.$router.push({path: '/user/index'})
          } else {
            this.$message({
              type: 'error',
              message: '没有权限！'
            })
            return false
          }
        })
      },
      addDevices() {
        let user = JSON.parse(window.localStorage.getItem('userData'))
        checkAuth({phone: user.phone}).then(res => {
          if (res.code == 200 && res.auth.indexOf('1') > -1) {
            this.$router.push({path: '/device/index'})
          } else {
            this.$message({
              type: 'error',
              message: '没有权限！'
            })
            return false
          }
        })
      },
      addGroup() {
        let user = JSON.parse(window.localStorage.getItem('userData'))
        checkAuth({phone: user.phone}).then(res => {
          if (res.code == 200 && res.auth.indexOf('3') > -1) {
            this.$router.push({path: '/device/group'})
          } else {
            this.$message({
              type: 'error',
              message: '没有权限！'
            })
            return false
          }
        })
      },
      addTask() {
        let user = JSON.parse(window.localStorage.getItem('userData'))
        checkAuth({phone: user.phone}).then(res => {
          if (res.code == 200 && res.auth.indexOf('4') > -1) {
            this.$router.push({path: '/task/index'})
          } else {
            this.$message({
              type: 'error',
              message: '没有权限！'
            })
            return false
          }
        })
      },
    }
  }
</script>

<style scoped>
  .infos {
    display: flex;
    padding: 20px 0px;
  }

  .head-lists {
    width: 100%;
    margin: 0px auto;
    background-color: #EFEEF0;
  }

  .weather-list {
    float: left;
    width: 50%;
  }

  .weather-pic {
    width: 30%;
    margin-top: 30px;
    display: flex;
  }

  .right-list {
    width: 65%;
    margin-left: 5%;
  }

  .indicate span:nth-child(2) {
    float: right;
    margin-right: 15%;
  }

  .application {
    margin-left: 1%;
  }

  .title, .title1 {
    margin: 10px 20px 0px;
    line-height: 30px;
  }

  .wa-list, .application {
    width: 49.5%;
    height: 160px;
    background-color: #fff;
    float: left;
  }

  .title span:nth-child(1), .title1 span:nth-child(1) {
    font-size: 18px;
  }

  .title1 span:nth-child(2) {
    margin-left: 10px;
    color: rgba(0, 0, 0, 0.4);
    font-size: 12px;
  }

  .wa-go:hover, .application-list > div:hover, .notice-info > div:nth-child(2) span:nth-child(2):hover, .data-div:hover {
    cursor: pointer;
  }

  .wa-go {
    float: right;
    color: rgba(0, 0, 0, 0.9);
    font-size: 12px;
  }

  .application-list {
    margin: 20px;
  }

  .application-list div {
    width: 25%;
    float: left;
    display: grid;
    text-align: center;
  }

  .application-list div span {
    font-size: 12px;
  }

  .application-list div img {
    width: 60px;
    height: 60px;
    margin: 0px auto 10px;
  }

  .notice-div, .datum-div {
    margin-top: 20px;
    width: 49.5%;
    height: 300px;
    background-color: #fff;
    float: left;
    margin-bottom: 60px;
  }

  .datum-div {
    margin-left: 1%;
  }

  .notice-info {
    border-bottom: 1px solid #E7E7E7;
    padding-bottom: 20px;
    padding-left: 20px;
    height: 60px;
  }

  .notice-datum {
    height: 50%;
  }

  .notice-info div:nth-child(2) span:nth-child(1) {
    color: rgba(0, 0, 0, 0.6);
  }

  .notice-info div:nth-child(2) span:nth-child(2) {
    float: right;
    margin-right: 20px;
    color: #0052D9;
  }

  .notice-info div:nth-child(2) {
    padding-top: 10px;
  }

  .notice-info div:nth-child(1) {
    padding-top: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.9);
  }

  .data-div div {
    width: 100%;
  }

  .data-div {
    width: 31%;
    height: 110px;
    margin: 10px 1%;
    float: left;
    background-color: #F7F8FA;
    border-radius: 10px;
  }

  .data-img {
    width: 25px;
    height: 25px;
    margin-top: 10px;
  }

  .data-second {
    display: flex;
  }

  .data-second span:nth-child(2) {
    font-size: 16px;
    margin-top: 15px;
    margin-left: 71%;
  }

  .data-three {
    text-indent: 10px;
    font-size: 12px;
  }

  .data-second span:nth-child(1) {
    color: #0052D9;
    font-size: 40px;
    text-indent: 10px;
    font-weight: bolder;
  }

  .data-info {
    width: 82%;
    font-size: 16px;
    text-indent: 10px;
    margin-top: 0px;
  }

  .data-first {
    height: 40px;
    line-height: 40px;
    display: flex;
  }

  .cloud {
    background-color: #0DAC78;
    color: #fff;
    padding: 3px 10px;
    border-radius: 5px;
  }

  .sun span:nth-child(2) {
    font-size: 12px;
  }

  .sun span:nth-child(1) {
    font-size: 22px;
    color: #000000;
  }

  .sun {
    margin-left: 10px;
    display: grid;
  }

  .indicate {
    width: 50%;
    float: left;
    margin-top: 10px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
  }

  .notices {
    display: none;
    width: 350px;
    position: absolute;
    z-index: 666666;
    right: 10vw;
    top: 50px;
    background-color: #FEFFFF;
    border: 1px solid #DCDCDC;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }

  .nlist {
    height: 70px;
    width: 90%;
    margin: 10px auto;
    padding: 10px;
    color: rgba(0, 0, 0, 0.4);
    border-bottom: 1px solid #E7E7E7;
  }

  .nlist p:nth-child(1) {
    color: #000000;
    margin-bottom: 10px;
    min-height: 40px;
  }

  .nlist-active p:nth-child(1) {
    color: #0052D9;
  }

  .nlist-active {
    background-color: #F3F3F3;
    border-radius: 3px;
  }

  .notice-time {
    float: right;
  }

  .look-all {
    color: #0052D9;
    text-align: center;
    margin: 15px 0px;
  }

  .notice-all {
    display: none;
    position: absolute;
    z-index: 8888888;
    background-color: rgba(238, 238, 238, 0.8);
    width: 88vw;
    left: 11vw;
    height: 90vh;
  }

  .notice-list {
    width: 96%;
    margin: 0px auto 30px;
    border-bottom: 1px solid #E7E7E7;
  }

  .mt0 {
    margin-top: 0px !important;
  }

  .notice-list1 {
    width: 96%;
    margin: 0px auto 30px;
    min-height: 60px;
    display: flex;
    border-bottom: 1px solid #E7E7E7;
  }

  .notice-type {
    float: left;
  }

  .mt12 {
    margin-top: 12px !important;
  }

  .notice-content p {
    display: flex;
  }

  .unread {
    background-color: red;
    width: 8px;
    height: 8px;
    margin-top: 5px;
    margin-right: 10px;
    border-radius: 8px;
  }

  .ml1010 {
    margin-left: 15px;
  }

  .ncontent {
    width: 90%;
    height: 20px;
    margin-top: -14px;
    overflow: hidden;
  }

  .title-notice {

  }

  .delete-action {
    width: 96%;
    display: flex;
    margin: 10px auto 40px;
    padding-bottom: 20px;
  }

  .delete-button {
    width: 100px;
    height: 40px;
    color: #fff !important;
    padding: 3px 6px;
  }

  .notice-detail {
    position: absolute;
    right: 28vw;
    color: #0052D9;
  }

  .all-div {
    width: 40%;
    margin: 10vh auto;
    background-color: #fff;
  }

  .read {
    background-color: #D4E3FC;
    color: #0052D9 !important;
    float: right;
    padding: 0px 10px;
  }

  .notice-title1 {
    padding: 30px 15px;
    font-size: 16px;
    font-weight: bolder;
  }

  .notice-title {
    margin: 20px auto;
    text-align: center;
  }

  .notice-title span:nth-child(2) {
    position: absolute;
    color: #0052D9;
    right: 10px;
  }

  .head-lists li {
    width: 23%;
    height: 180px;
    margin-right: 1%;
    background-color: #ffffff;
    float: left;
    border-radius: 3px;
  }

  .head-lists li div {
    margin: 20px;
    font-size: 16px;
  }

  .count {
    font-size: 40px !important;
    display: flex;
  }

  .count div {
    width: 70px;
    height: 70px;
    border-radius: 70px;
  }

  .gb {
    margin-top: -10px !important;
    margin-left: 60% !important;
  }

  .gb img {
    width: 80px;
    height: 80px;
  }

  .info-bottom {
    opacity: 0.5;
  }

  .info-bottom1 {
    margin-top: -20px !important;
  }

  .head-lists .users {
    background: url("/static/images/user-bg.png") no-repeat;
    background-size: 100% 100%;
    color: #fff;
    height: 140px;
  }

  .right-arrow1 {
    float: right;
    width: 16px;
    height: 16px;
    margin-top: 5px;
  }

  .mr30 {
    margin-right: 30px;
  }

  .abmt20 {
    margin-top: 30%;
    background-color: #fff;
  }

  .ml10 {
    margin-left: 10px;
  }

  .count-num {
    margin-top: 10px;
    color: rgba(0, 0, 0, 0.6);
  }

  .info-desc {
    opacity: 0.5;
  }

  .green {
    color: #0DAC78 !important;
    opacity: 1 !important;
  }

  .greenbg {
    background: rgba(13, 172, 120, 0.15);
    font-size: 12px;
    padding: 4px 8px;
    font-weight: 400;
    line-height: 22px;
    color: #0DAC78;
  }

  .orange {
    color: #ED7B2F;
  }

  .fl50 {
    margin-left: 50px;
  }

  .mt30 {
    margin-top: 30px;
  }

  .mb30 {
    margin-bottom: 30px;
  }

  .w43 .tips {
    height: 55px;
    line-height: 55px;
    background-color: #fff;
    font-size: 16px;
  }

  .w41 {
    width: 24vw;
    height: 91vh;
    margin-left: 1vw;
    float: left;
  }

  .tips .title {
    font-size: 18px;
    margin-left: 34px;
    font-weight: bold;
  }

  .address {
    margin-left: 20px;
  }

  .tips span:nth-child(2) {
    color: rgba(0, 0, 0, 0.6);
    text-align: right;
  }

  .tips1 {
    width: 71vw;
    position: absolute;
    right: 29vw;
    z-index: 10000;
    height: 40px;
    line-height: 40px;
    display: flex;
    margin-top: -40px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, #FFFFFF 100%);
  }

  .tips1 div {
    position: absolute;
    right: 1vw;
  }

  .tips1 p {
    float: left;
    line-height: 40px;
    font-size: 14px;
  }

  .tips1 p:nth-child(2n+1) {
    width: 30px;
    height: 15px;
    margin-top: 12px;
    margin-right: 10px;
    border-radius: 10px;
  }

  .tips1 p:nth-child(2n+2) {
    width: 80px !important;
    height: 20px;
  }

  .leave {
    background-color: #808080;
  }

  .stop {
    background-color: #E34D59;
  }

  .alarm {
    background-color: #ED7B2F;
  }

  .run {
    background-color: #0DAC78;
  }

  .times {
    float: right;
    margin-right: 40px;
  }

  .h400 {
    height: 180px;
  }

  .weather {
    height: 20vh;
    background-color: #fff;
  }

  .devices {
    height: 62vh;
    font-size: 16px;
    background-color: #fff;
    border-radius: 3px;
    margin-top: 1.5vh;
  }

  .device-type {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #E7E7E7;
  }

  .w60 div {
    width: 50%;
    line-height: 50px;
    float: left;
    text-align: center;
  }

  .on {
    color: #0052D9;
    border-bottom: 2px solid #0052D9 !important;
  }

  .w60 {
    width: 100%;
    height: 7vh;
    margin: 0 auto;
  }

  .device-title {
    width: 100%;
    height: 7vh;
    line-height: 7vh;
    display: flex;
    border-bottom: 1px solid #E7E7E7;
  }

  .group-list img:nth-child(1) {
    width: 14px;
    height: 14px;
  }

  .red-area {
    background-color: #ff0000;
    height: 10px;
    width: 20px;
    border-radius: 3px;
    margin-top: 2.5vh;
    margin-right: 10px;
  }

  .green-area {
    background-color: #0DAC78;
    height: 10px;
    width: 20px;
    border-radius: 3px;
    margin-top: 2.5vh;
    margin-right: 10px;
  }

  .leave-area {
    background-color: #808080;
    height: 10px;
    width: 20px;
    border-radius: 3px;
    margin-top: 2.5vh;
    margin-right: 10px;
  }

  .alarm-area {
    background-color: #ED7B2F;
    height: 10px;
    width: 20px;
    border-radius: 3px;
    margin-top: 2.5vh;
    margin-right: 10px;
  }

  .span-red {
    color: #ff0000 !important;
    margin-right: 5px;
  }

  .contents {
    height: 45vh;
    padding: 0px 5%;
  }

  .device-name {
    padding-left: 10px;
    width: 50%;
    font-size: 18px;
  }

  .group-right {
    width: 50%;
    text-align: right;
    margin-right: 10px;
  }

  .group-right span {
    margin: 0 10px;
  }

  .group-select {
    background-color: #E7E7E7;
  }

  .group-right-arrow {
    width: 10px !important;
    height: 14px !important;
  }

  .notice-time1 {
    margin-top: 10px;
    float: right;
  }

  .notice-time {
    margin-top: 10px;
    float: left;
  }

  .edit {
    color: #0052D9;
    position: absolute;
    right: 5%;
  }

  #details:hover {
    cursor: pointer;
  }

  .edit:hover {
    cursor: pointer;
  }

  .serial-number1 {
    color: rgba(0, 0, 0, 0.9);
    margin-top: 5px;
    padding-bottom: 10px;
    font-size: 12px;
    border-bottom: 1px solid #E7E7E7;
  }

  #device-detail {
    display: none;
  }

  .device-detail {
    padding-top: 20px;
  }

  .device-detail div {
    line-height: 40px;
  }

  .device-detail .right {
    position: absolute;
    right: 5%;
  }

  .device-detail .right a {
    margin-left: 20px;
    color: #0052D9;
  }

  .actions {
    margin-top: 1.5vh;
    width: 100%;
    background-color: #fff;
    height: 12vh;
  }

  .actions ul {
    width: 70%;
    margin: 0 auto;
  }

  .actions li {
    width: 32%;
    float: left;
    height: 80px;
    font-size: 16px;
    display: grid;
    text-align: center;
    margin: 10px 0.5% 0px;
  }

  .actions li img {
    margin: 0 auto;
  }

  .all-check input {
    margin-right: 10px;
  }

  .select-all {
    color: #0052D9;
  }

  .all-check {
    display: none;
    margin-top: 10px;
    padding-bottom: 10px;
  }

  .check-list {
    height: 42vh;
  }

  .check-list p input {
    display: none;
    margin-right: 10px;
  }

  .check-list p {
    display: flex;
    height: 40px;
    line-height: 40px;
  }

  #group-detail {
    height: 50vh;
    bottom: 2vh;
  }

  .delete-group {
    display: none;
  }

  .delete-group button {
    background-color: #0052D9;
    border: none;
    padding: 5px 10px;
    color: #fff;
  }

  .grey {
    color: rgba(0, 0, 0, 0.4);
  }

  .alarms {
    margin: 0 auto;
    padding: 20px;
    background-color: #fff;
  }

  .alarms h2 {
    margin-bottom: 30px;
    font-weight: bold;
  }

  .blue {
    color: #0052D9;
  }

  .alert {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 999;
    top: 0px;
    display: none;
    background-color: rgba(0, 0, 0, 0.1);
  }

  .device-alert {
    width: 400px;
    height: 150px;
    margin: 200px auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 3px;
  }

  .move-group {
    margin-top: 30px;
  }

  .layui-input-inline select {
    margin-left: 20px;
    height: 30px;
    width: 300px;
  }

  .bgblue {
    background-color: #0052D9;
    color: #fff;
  }

  .device-button {
    margin: 40px auto 0px;
    text-align: center;
  }

  .device-button button {
    margin: 0 10px;
    padding: 5px 10px;
    border: none;
    border-radius: 3px;
  }

  .params {
    display: none;
  }

  .user-alert {
    display: none;
  }

  .params, .user-alert {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 9999;
    top: 0px;
    background-color: rgba(0, 0, 0, 0.1);
  }

  .params-alert, .user-content {
    width: 600px;
    margin: 200px auto;
    background-color: #fff;
    padding: 20px;
  }

  .users {
    width: 96%;
    height: 400px;
    padding: 20px;
    margin: 0px auto;
    background-color: #ffffff;
  }

  .users-list {
    height: 100%;
    margin-top: 40px;
  }

  .user-div {
    width: 22.8%;
    height: 100px;
    margin: 20px 1%;
    float: left;
    border: 1px solid #EEEEEE;
  }

  .user-div div {
    float: left;
  }

  .avatar, .user-delete {
    line-height: 100px;
  }

  .avatar {
    margin-left: 20px;
  }

  .user-delete {
    float: right !important;
    margin-right: 20px;
  }

  .user-info {
    margin-left: 20px;
    padding-top: 25px;
  }

  .user-info div {
    margin-top: 10px;
    width: 100%;
  }

  .add-user {
    line-height: 100px;
    text-align: center;
    background-color: #F3F3F3;
    font-size: 14px;
  }

  .add-user span {
    color: #0052D9;
  }

  .auth-list {
    width: 60% !important;
  }

  .auth-list div {
    width: 45%;
    line-height: 35px;
    float: left;
    margin-left: 4%;
  }

  .auth-list div input {
    margin-top: 0px !important;
  }

  .update-phone {
    width: 96%;
    height: 400px;
    background-color: #fff !important;
  }

  .update-phone-center {
    width: 70%;
    margin: 0px auto;
    padding-top: 50px;
    padding-left: 50px;
  }

  .update-phone-center h2 {
    padding-bottom: 30px;
  }

  .update-phone-center > .device-button {
    text-align: left;
    margin-left: 70px;
  }

  .group-detail-header {
    display: flex;
    height: 30px;
  }

  .group-detail-header span {
    font-size: 16px;
    line-height: 30px;
  }

  .group-detail-header a {
    background-color: #0052D9;
    color: #fff;
    border-radius: 3px;
    line-height: 30px;
    padding: 0 10px;
    position: absolute;
    margin-right: 10%;
    right: 20%;
  }

  .group-base {
    margin-top: 20px;
  }

  .base-title {
    border-left: 3px solid #0052D9;
    padding-left: 10px;
    font-size: 14px;
    margin-top: 20px;
  }

  .base-title span {
    margin-left: 15px;
    font-size: 12px;
  }

  .group-base-info {
    margin-top: 20px;
  }

  .group-base .layui-form-item .layui-input-inline {
    width: 300px !important;
    margin-top: 5px;
  }

  .group-base .layui-form-label {
    width: auto !important;
    text-align: left !important;
    border-radius: 3px;
  }

  .intro {
    padding: 0px 15px 20px;
  }

  .intro span:nth-child(2), .intro a {
    margin-left: 20px;
  }

  .group-devices {
    border-radius: 3px;
    min-height: 200px;
    border: 1px solid #E5E5E5;
    padding: 0px 20px;
    margin-top: 20px;
  }

  .group-devices-left, .group-devices-right {
    width: 48%;
    height: 100%;
    padding-top: 15px;
    float: left;
    display: inline-block;
    min-height: 185px;
  }

  .group-devices-left {
    border-right: 1px solid #E5E5E5;
  }

  .group-devices-right {
    padding-left: 2%;
  }

  .group-devices-right p span {
    float: right !important;
  }

  .checkboxes {
    margin-top: 10px;
  }

  .have-devices1 {
    height: 160px;
    overflow-y: scroll;
    padding-right: 20px;
  }

  .action-button {
    padding: 5px 15px !important;
    margin-right: 5px;
    border: none;
    color: #fff;
    border-radius: 5px;
  }

  .update-devices {
    width: 96%;
    background-color: #fff !important;
  }

  .pressure-mpa {
    position: absolute;
    margin-top: 8px;
    margin-left: 89%;
  }

  .minus {
    float: right;
    /*position: absolute;*/
    right: 20%;
  }

  .device-div {
    margin-top: 10px;
  }

  .group-base-info {
    margin-top: 20px;
  }

  .mode-list select {
    margin-left: 0px !important;
    color: #000000;
  }

  .delete-button {
    background-color: #E7E7E7;
    color: rgba(0, 0, 0, 0.9);
    height: 26px;
    width: 50px;
  }

  .group-button {
    margin-top: 20px;
    padding-bottom: 20px;
  }

  .task-type span {
    width: 50px;
  }

  .task-type select {
    width: 150px;
    margin-right: 30px;
    margin-top: 5px;
  }

  .method-type {
    display: flex;
  }

  .method-type span {
    margin-right: 30px;
    line-height: 40px;
  }

  .tasks-type-select {
    width: 600px;
    display: flex;
  }

  .tasks-type-select span {
    margin-right: 25px;
    line-height: 40px;
  }

  .time-section {
    margin-top: 20px;
  }

  .time-section span:nth-child(2) {
    border: 1px solid #DCDCDC;
    padding: 5px 10px;
    line-height: 30px;
  }

  .time-section select {
    width: 300px;
    height: 30px;
  }

  .time-section img {
    margin-left: 10px;
    width: 12px;
  }

  .time-add {
    width: 90px;
    margin: 10px 0px 10px 70px;
  }

  .time-add span {
    line-height: 20px;
  }

  .blue-bg {
    background-color: #0052D9;
    border: none;
    color: #fff;
    padding: 6px 10px;
    border-radius: 3px;
  }

  .green1-bg {
    background-color: #009688;
    border: none;
    color: #fff;
    padding: 6px 10px;
    border-radius: 3px;
  }

  .grey-bg {
    background-color: #E7E7E7 !important;
    color: #000000 !important;
    border-radius: 3px;
    padding: 6px 15px;
    border: none;
    margin-right: 10px;
  }

  .red-bg {
    width: 20px;
    height: 10px;
    border-radius: 5px;
    margin: 5px 5px 0 0px;
    background-color: red;
  }

  .orange-bg {
    width: 20px;
    height: 10px;
    border-radius: 5px;
    margin: 5px 5px 0 0px;
    background-color: #ED7B2F;
  }

  .grey1-bg {
    width: 20px;
    height: 10px;
    border-radius: 5px;
    margin: 5px 5px 0 0px;
    background-color: #808080;
  }

  .green-bg {
    width: 20px;
    height: 10px;
    border-radius: 5px;
    margin: 5px 5px 0 0px;
    background-color: #0DAC78;
  }

  .white-bg {
    background-color: #fff;
  }

  #select_device {
    color: rgba(0, 0, 0, 0.4);
    margin-left: 10px;
  }

  .data-count {
    margin: 15px 0px;
    color: rgba(0, 0, 0, 0.6);
  }

  .status-close {
    color: #E34D59;
  }

  .status-alarm {
    color: #ED7B2F;
  }

  .status-run {
    color: #0DAC78;
  }

  .status-leave {
    color: rgba(0, 0, 0, 0.9);
  }

  .param-info {
    background-color: #F3F3F3;
    width: 100%;
    height: 120px;
    margin: 20px 0px;
    padding-top: 10px;
  }

  .params-list {
    width: 40%;
    float: left;
    padding-right: 4%;
    margin: 10px 20px;
  }

  .params-list span:nth-child(2) {
    float: right;
    margin-right: 5%;
  }

  #iboxcontent {
    width: 71vw !important;
    height: 90vh !important;
  }

  .layui-form-checked span, .layui-form-checked:hover span {
    background-color: #0052D9 !important;
    color: #fff;
  }

  .layui-form-checked i, .layui-form-checked:hover i {
    color: #0052D9 !important;
  }

  .user-list {
    width: 48%;
    margin: 15px 1% 0px 0px !important;
    float: left;
  }

  .red1 {
    color: red;
    margin-right: 5px;
  }

  .list {
    margin-left: 115px !important;
  }

  .input1 {
    width: 80%;
  }

  .update-phone-center .layui-form-item .layui-input-inline {
    width: 400px;
  }

  #code1 {
    height: 30px;
    position: absolute;
    margin-top: -30px;
    padding: 0 10px;
    right: 0px;
  }

  #time {
    display: none;
    height: 30px;
    line-height: 30px;
    position: absolute;
    font-size: 14px;
    margin-top: -30px;
    padding-right: 10px;
    right: 0px;
  }

  .inline {
    display: flex !important;
  }

  .device-serial {
    position: absolute;
    margin-left: 100%;
    width: 65px;
    text-align: center;
    padding: 0 10px;
  }

  .device-serial1 {
    position: absolute;
    margin-left: 115%;
    width: 50px;
    text-align: center;
    padding: 0 10px;
  }

  .x-so input.layui-input {
    width: 295px !important;
  }

  .mpa {
    position: absolute;
    right: 10px;
    margin-top: -35px;
  }

  #view a {
    margin-right: 20px;
  }

  .task-group {
    width: 300px;
  }

  .device-search button {
    margin-left: 20px;
  }

  .add-fresh {
    height: 25px;
    line-height: 15px;
    font-size: 12px;
    position: absolute;
    right: 10%;
  }

  .add-fresh1 {
    height: 25px;
    line-height: 15px;
    font-size: 12px;
    position: absolute;
    right: 2.5%;
  }

  .add-group {
    height: 25px;
    line-height: 15px;
    font-size: 12px;
    position: absolute;
    right: 2.5%;
  }

  .protocal, .teach {
    width: 100%;
    position: absolute;
  }

  .protocal {
    bottom: 80px;
  }

  .teach {
    bottom: 40px;
  }

  .view-list {
    position: absolute;
    bottom: 15px;
  }

  .agreement-header {
    text-align: center;
    font-size: 20px;
    padding: 60px 0px 20px;
  }

  .agreement-content {
    padding: 20px;
  }

  .agreement-content {
    line-height: 30px;
  }

  .back {
    position: absolute;
    width: 80px;
    margin: 15px 15px 50px;
    background-color: #0052D9;
    color: #fff;
    padding: 5px 0px;
    border-radius: 5px;
    text-align: center;
  }

  .jiaocheng-content {
    width: 700px;
    margin: 20px auto;
  }

  #lock-img:hover, #auto-img:hover, #action-img:hover {
    cursor: pointer;
  }
</style>





// WEBPACK FOOTER //
// src/views/home/index.vue